<div [hidden]="hidden">
  <div
    class="d-flex justify-content-center alert alert-default background-default"
  >
    <span>{{ message }} ...</span>
  </div>
</div>
